// extracted by mini-css-extract-plugin
module.exports = {"label":"price_label___Fw_r font-bold inline-block mr-2","content":"price_content__Iq9Ht inline-block"};